export default {"src":"/_next/static/media/mortgage.426ba869.svg","height":116,"width":140};